<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row v-if="!loading">
      <v-col cols="12" class="py-1">
        <v-toolbar color="transparent" flat>
          <v-toolbar-title class="headline-header text-h6 px-0">{{ title }}</v-toolbar-title>
          <v-spacer />
          <v-btn depressed rounded color="green" dark :to="{ name: 'frota.veiculo' }">
            <v-icon>mdi-arrow-left</v-icon>
            Voltar
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-divider class="pb-2 divider-header" />
    <v-card v-if="!loading" outlined>
      <v-card-text>
        <v-simple-table class="table-bordered" dense>
          <template v-slot:default>
            <tbody>
              <tr>
                <td colspan="2">
                  <small><b>Marca/Modelo</b></small>
                  <br />
                  {{ data.marca_modelo || '---' }}
                </td>
                <td colspan="2">
                  <small><b>Combustível</b></small>
                  <br />
                  {{ data.combustiveis.map((c) => c.nome).join(' | ') || '---' }}
                </td>
              </tr>
              <tr>
                <td width="25%" colspan="1">
                  <small><b>Placa</b></small>
                  <br />
                  {{ data.placa || '---' }}
                </td>
                <td width="25%" colspan="1">
                  <small><b>Ano</b></small>
                  <br />
                  {{ data.ano || '---' }}
                </td>
                <td width="25%" colspan="1">
                  <small><b>Renavam</b></small>
                  <br />
                  {{ data.renavam || '---' }}
                </td>
                <td width="25%" colspan="1">
                  <small><b>Cor</b></small>
                  <br />
                  {{ data.cor.nome || '---' }}
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <small><b>Categoria</b></small>
                  <br />
                  {{ data.categoria.nome || '---' }}
                </td>
                <td colspan="1">
                  <small><b>Vínculo</b></small>
                  <br />
                  {{ data.vinculo.nome || '---' }}
                </td>
                <td colspan="1">
                  <small><b>Ativo?</b></small>
                  <br />
                  {{ data.ativo ? 'Sim' : 'Não' }}
                </td>
                <td colspan="1">
                  <small><b>Importado?</b></small>
                  <br />
                  {{ data.importado ? 'Sim' : 'Não' }}
                </td>
              </tr>
              <tr>
                <td width="25%">
                  <small><b>Estado da Pintura</b></small>
                  <br />
                  {{ data.estado_pintura.nome || '---' }}
                </td>
                <td width="25%">
                  <small><b>Estado do Pneu</b></small>
                  <br />
                  {{ data.estado_pneu.nome || '---' }}
                </td>
                <td width="25%">
                  <small><b>Estado da Mecânica</b></small>
                  <br />
                  {{ data.estado_mecanica.nome || '---' }}
                </td>
                <td width="25%">
                  <small><b>Estado Geral</b></small>
                  <br />
                  {{ data.estado_geral.nome || '---' }}
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <small><b>Observação</b></small>
                  <br />
                  {{ data.observacao || '---' }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <VeiculoLotacaoTable />
    <VeiculoMotoristaTable />
    <VeiculoRotaTable />
    <v-divider class="py-2"></v-divider>
    <VeiculoDocumentoTable />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import VeiculoLotacaoTable from './tables_show/TableLotacao.vue';
import VeiculoMotoristaTable from './tables_show/TableMotorista.vue';
import VeiculoRotaTable from './tables_show/TableRota.vue';
import VeiculoDocumentoTable from './tables_show/TableDocumento.vue';

export default {
  name: 'MotoristaShow',
  components: {
    VeiculoDocumentoTable,
    VeiculoRotaTable,
    VeiculoMotoristaTable,
    VeiculoLotacaoTable,
  },
  metaInfo: {
    title: 'Informações do Veículo',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    title: 'Informações do Veículo',
    tab: null,
    loading: false,
  }),
  created() {
    this.loadMotorista();
  },
  methods: {
    ...mapActions('veiculo', ['find']),
    loadMotorista() {
      this.loading = true;
      this.find({ id: this.$route.params.id }).finally(() => {
        this.loading = false;
      });
    },
  },
  computed: {
    ...mapState('veiculo', ['data']),
  },
};
</script>

<style lang="scss">
.table-bordered {
  border: thin solid rgba(0, 0, 0, 0.12);

  tr td {
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }

  tr td:nth-child(1) {
    border-left: none;
  }
}
</style>
